import { createContext } from 'react';

const placeholder = (name) => () => {
  throw new Error(`${name} is not defined`);
};

const Context = createContext({
  module: '',

  allowedMimeTypes: [],
  maxFileSize: undefined,
  assets: [],

  title: '',
  buttonText: '',
  createTitle: '',
  updateTitle: '',
  tagsSubTitle: '',
  namePlaceholder: '',
  tagsPlaceholder: '',
  placeholder: '',
  saveButtonText: '',

  files: [],
  index: 0,
  modalPercent: 0,
  data: {},
  isModalOpened: false,
  isModalLoader: false,
  isGlobalLoader: false,
  errors: {},
  search: '',

  editorAdditionalFields: null,

  onSearchType: placeholder('onSearchType'),
  onLoadChunk: placeholder('onLoadChunk'),
  onSelectFile: placeholder('onSelectFile'),
  onDelete: placeholder('onDelete'),
  onOpenModal: placeholder('onOpenModal'),
  onCloseModal: placeholder('onCloseModal'),
});

export default Context;
